import React from "react";
import cogoToast from "cogo-toast";

class QuizImgBased extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      error: "",
      optionSelected: "",
      quiz_data: {
        quiz_title: ""
      },
      question_list: {
        question_title: "",
        question_media: [{
          media_path: ""
        }],
        question_options: [{
          option_name: "",
          option_id: ""
        }]
      },
      ans: [],
      count: 0,
      rightAns: "none",
      wrongAns: "none",
      quiz_answers: [],
      date: 0
    };
  }
  componentDidMount() {
    this.timerID = setInterval(() => this.tick(), 1000);
  }
  tick() {
    this.setState({ date: this.state.date + 1 });
  }
  componentWillMount() {
    this.setState({
      question_list: this.props.unitDetails,
      quiz_data: this.props.Details.quiz_list[0],
      start: this.state.date
    });
    this.setState({ quiz_data: this.props.Details.quiz_list[0] });
  }

  componentDidUpdate(prevProps) {
    if (
      this.props.unitDetails.question_id !== prevProps.unitDetails.question_id
    ) {
      this.setState({ question_list: this.props.unitDetails });
    }
  }

  componentWillUnmount() {
    clearInterval(this.timerID);
  }

  findAns = ans => {
    return this.state.question_list.question_options.find(item => {
      return parseInt(item.option_id, 10) === parseInt(ans, 10);
    });
  };

  onOptionSelection = event => {
    event.target.classList.add("selected-radio");
    const allRadioButtons = document.querySelectorAll(".radio-button");
    for (let i = 0; i < allRadioButtons.length; i++) {
      allRadioButtons[i].classList.add("disabled");
    }
    this.setState({ error: "" });
    this.setState({ optionSelected: event.target.value });
    this.setState({ rightAns: "none", wrongAns: "none" });
    this.setState({ ans: this.state.optionSelected });
    // var ans = this.findAns(event.target.id);
    let quiz = this.state.quiz_answers;
    let obj = {};
    obj.quiz_unit_id = this.state.quiz_data.quiz_unit_id;
    obj.course_unit_id = this.props.Details.course_unit_id;
    obj.coursemaster_id = this.props.Details.coursemaster_id;
    obj.question_id = this.state.question_list.main_question_id;
    obj.start_time = this.state.start;
    obj.no_of_attempted = 1;
    obj.total_point = 5;
    if (event.target.getAttribute("data") == 1) {
      this.setState({ rightAns: "block", wrongAns: "none" });
      obj.answer_id = event.target.id;
      obj.obtained_score = this.state.quiz_data.marks_for_correct_answer;
      obj.accuracy = (100 * this.state.quiz_data.marks_for_correct_answer) / this.state.quiz_data.marks_for_correct_answer;
      obj.obtained_point = 5;

      this.props.playCorrectAudio();

      cogoToast.success("Correct", { position: "top-center" });

      setTimeout(() => {
        this.nextque();
        if (document.querySelector(".selected-radio")) {
          document.querySelector(".selected-radio").classList.remove("selected-radio");
        }
        for (let i = 0; i < allRadioButtons.length; i++) {
          allRadioButtons[i].classList.remove("disabled");
        }
      }, 3500);
    } else {
      cogoToast.error("Wrong", { position: "top-center" });
      this.setState({ rightAns: "none", wrongAns: "block" });
      obj.answer_id = event.target.id;
      obj.obtained_score = 0;
      obj.accuracy = (100 * 0) / this.state.quiz_data.marks_for_correct_answer;
      obj.obtained_point = 0;

      const allRadioButton = document.querySelectorAll(".radio-button");
      this.props.playIncorrectAudio();
      setTimeout(() => {
        this.nextque();
        if (document.querySelector(".selected-radio")) {
          document.querySelector(".selected-radio").classList.remove("selected-radio");
        }
        for (let i = 0; i < allRadioButtons.length; i++) {
          allRadioButtons[i].classList.remove("disabled");
        }
      }, 3500);
    }
    obj.time_spent_duration = parseInt(this.state.date) - parseInt(this.state.start);
    obj.total_score = this.state.quiz_data.marks_for_correct_answer;
    obj.end_time = this.state.date;
    if (localStorage.getItem("quiz")) {
      var scores = JSON.parse(localStorage.getItem('quiz'))
      var exist = false
      for (let i = 0; i < scores.length; i++) {
        if(obj.question_id == scores[i].question_id){
          scores[i] = obj
          exist = true
          localStorage.setItem("quiz", JSON.stringify(scores));
        }
      }
      if(!exist){
        var cart = [];
        cart = JSON.parse(localStorage["quiz"]);
        cart.push(obj);
        localStorage.setItem("quiz", JSON.stringify(cart));
      }
    } else {
      var arra = [];
      arra.push(obj);
      localStorage.setItem("quiz", JSON.stringify(arra));
    }
  };

  nextque = () => {
    this.props.parentMethod();
  };
  render() {
    return (
      <div className="quiz-model quiz_child quiz_sentence_type text-center">
        <div className="rounded">
          <div className="heading-block">
            <h3
              className="text-4 text-black m-0 question-quiz"  id="question_title"
              dangerouslySetInnerHTML={{
                __html: this.state.question_list.question_title
              }}
            ></h3>
          </div>
          <div className="modal-body">
            <div className="row inner-game-container mx-auto">
              {/* {
                this.state.question_list.answer_type_id !== "2" && this.state.question_list.question_type_id !== "7"
                  ?
                  <div className="col-md-6">
                    <figure
                      className="m-auto text-center"
                      style={{ opacity: this.state.opacity }}
                    >
                      {this.state.question_list.question_media !== null &&
                        this.state.question_list.question_media !== undefined &&
                        this.state.question_list.question_media !== [] &&
                        this.state.question_list.question_media.length > 0 ?
                        this.state.question_list.question_media.map(que_media =>
                          <img
                            alt=""
                            className="img-thumbnail img-fluid img-category quiz-image"
                            src={que_media.media_url ? que_media.media_url : ""}
                          />)
                        : ""}
                    </figure>
                  </div>
                  : null
              } */}

              <div className="d-flex justify-content-center flex-column">
                <div className="radio-div justify-content-center row">
                  {this.state.question_list.question_options.map((op, key) => (
                    <div
                      class="radio-button shadow-sm col"
                      id={key}
                      onClick={this.onOptionSelection.bind(this)}
                      data={op.right_answer}
                    >
                      <img src={op.media_url} alt="" className="img-thumbnail img-fluid img-category" data={op.right_answer} />
                    </div>
                  ))}
                </div>
              </div>
            </div>
          </div>
        </div>

        <div className="row d-flex justify-content-center my-3 next-btn">
          <div className="text-center text-danger text-3">
            <span> {this.state.error} </span>
          </div>
        </div>
      </div>
    );
  }
}
export default QuizImgBased;
